// src/Step5EquipmentConfirm.jsx
import React from 'react';

const EQUIPMENT_OPTIONS = [
  {
    value: '0',
    label: 'فقط وزن بدن',
    desc: 'بدون دمبل، کش یا دستگاه',
    icon: '🧍',
  },
  {
    value: '1',
    label: 'وزن بدن + دمبل',
    desc: 'برای تمرین خانگی بهتر',
    icon: '🏋️',
  },
  {
    value: '2',
    label: 'وزن بدن + کش',
    desc: 'مناسب تمرین سبک و قابل حمل',
    icon: '🪢',
  },
  {
    value: '3',
    label: 'باشگاه کامل',
    desc: 'دسترسی به دستگاه و وزنه آزاد',
    icon: '🏛️',
  },
];

const FREQUENCY_OPTIONS = [1, 2, 3, 4];

export default function Step5EquipmentConfirm({ form, setF, colors }) {
  const isDietOnly = Number(form.requestedPlan) === 2;

  return (
    <div>
      <SectionIntro
        colors={colors}
        title={isDietOnly ? 'مدت برنامه‌ریزی' : 'روزهای تمرین و تجهیزات'}
        subtitle={
          isDietOnly
            ? 'تعداد روزهای موردنظر برای برنامه‌ریزی تغذیه را مشخص کن.'
            : 'برای اینکه برنامه واقعاً قابل اجرا باشد، تعداد روزهای تمرین و تجهیزاتت را دقیق انتخاب کن.'
        }
      />

      <FieldTitle colors={colors}>
        {isDietOnly ? 'تعداد روزهای برنامه' : 'روزهای تمرین در هفته'}
      </FieldTitle>

      <div className="grid grid-cols-2 md:grid-cols-4 gap-3 mb-6">
        {FREQUENCY_OPTIONS.map((n) => (
          <FrequencyCard
            key={n}
            active={Number(form.frequency) === n}
            value={n}
            onClick={() => setF('frequency', n)}
            colors={colors}
            isDietOnly={isDietOnly}
          />
        ))}
      </div>

      {!isDietOnly ? (
        <>
          <FieldTitle colors={colors}>تجهیزات در دسترس</FieldTitle>

          <div className="grid sm:grid-cols-2 gap-3">
            {EQUIPMENT_OPTIONS.map((item) => (
              <EquipmentCard
                key={item.value}
                active={String(form.equipment) === String(item.value)}
                item={item}
                onClick={() => setF('equipment', item.value)}
                colors={colors}
              />
            ))}
          </div>

          <div
            className="mt-5 rounded-2xl border px-4 py-3 text-sm leading-7"
            style={{
              borderColor: colors.border,
              backgroundColor: 'rgba(37,99,235,0.08)',
              color: colors.sub,
            }}
          >
            اگر هم خانه تمرین می‌کنی هم باشگاه می‌ری، گزینه‌ای را انتخاب کن که بیشتر اوقات در دسترس داری.
          </div>
        </>
      ) : (
        <div
          className="rounded-2xl border px-4 py-4 text-sm leading-7"
          style={{
            borderColor: colors.border,
            backgroundColor: 'rgba(124,58,237,0.08)',
            color: colors.sub,
          }}
        >
          چون فقط رژیم و تغذیه انتخاب شده، تجهیزات تمرینی نیاز نیست و به‌صورت خودکار «باشگاه کامل» ثبت می‌شود تا ساختار بک‌اند کامل بماند.
        </div>
      )}
    </div>
  );
}

function SectionIntro({ title, subtitle, colors }) {
  return (
    <div
      className="mb-5 rounded-2xl border p-4"
      style={{
        borderColor: colors.border,
        backgroundColor: 'rgba(255,255,255,0.03)',
      }}
    >
      <h3 className="text-lg md:text-xl font-black mb-2">{title}</h3>
      <p className="text-sm leading-7" style={{ color: colors.sub }}>
        {subtitle}
      </p>
    </div>
  );
}

function FieldTitle({ children, colors }) {
  return (
    <h4 className="text-sm font-black mb-3" style={{ color: colors.text }}>
      {children}
    </h4>
  );
}

function FrequencyCard({ active, value, onClick, colors, isDietOnly }) {
  return (
    <button
      type="button"
      onClick={onClick}
      className="rounded-[22px] border p-4 text-center transition hover:scale-[1.01]"
      style={{
        borderColor: active ? '#3b82f6' : colors.border,
        backgroundColor: active ? 'rgba(37,99,235,0.16)' : colors.inputBg,
        boxShadow: active ? '0 14px 30px rgba(37,99,235,0.16)' : 'none',
      }}
    >
      <div
        className="text-2xl font-black mb-1"
        style={{ color: active ? '#bfdbfe' : colors.text }}
      >
        {value}
      </div>

      <div className="text-sm font-bold" style={{ color: colors.sub }}>
        {isDietOnly ? 'روز برنامه' : 'روز در هفته'}
      </div>

      <div
        className="mt-3 mx-auto w-6 h-6 rounded-full border flex items-center justify-center text-xs"
        style={{
          borderColor: active ? '#60a5fa' : colors.border,
          backgroundColor: active ? '#2563eb' : 'transparent',
          color: '#fff',
        }}
      >
        {active ? '✓' : ''}
      </div>
    </button>
  );
}

function EquipmentCard({ active, item, onClick, colors }) {
  return (
    <button
      type="button"
      onClick={onClick}
      className="rounded-[24px] border p-5 text-right transition hover:scale-[1.01]"
      style={{
        borderColor: active ? '#3b82f6' : colors.border,
        backgroundColor: active ? 'rgba(37,99,235,0.16)' : colors.inputBg,
        boxShadow: active ? '0 16px 35px rgba(37,99,235,0.16)' : 'none',
      }}
    >
      <div className="flex items-start justify-between gap-3">
        <div className="flex items-start gap-3">
          <span className="text-2xl shrink-0">{item.icon}</span>

          <div>
            <div className="font-black text-base mb-2">
              {item.label}
            </div>

            <div className="text-xs leading-6" style={{ color: colors.sub }}>
              {item.desc}
            </div>
          </div>
        </div>

        <span
          className="w-6 h-6 rounded-full border flex items-center justify-center text-xs shrink-0"
          style={{
            borderColor: active ? '#60a5fa' : colors.border,
            backgroundColor: active ? '#2563eb' : 'transparent',
            color: '#fff',
          }}
        >
          {active ? '✓' : ''}
        </span>
      </div>
    </button>
  );
}